var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbercar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4248 7.56446V12.1897L18.8509 13.1466C18.6523 13.4656 18.2991 13.6707 17.9239 13.6707H1.54722C1.17201 13.6707 0.818873 13.4656 0.620236 13.1466L0.0463867 12.1897V7.56446C0.0463867 7.04042 0.178815 6.51638 0.465738 6.06066L1.19408 4.85309L3.44533 1.07087C3.59982 0.820243 3.77638 0.61518 3.99711 0.455688C4.37229 0.159491 4.83579 0 5.29929 0H14.1498C14.6353 0 15.0768 0.159491 15.4519 0.455688C15.6727 0.61518 15.8492 0.843024 16.0037 1.07087L18.2771 4.85309L19.0054 6.06066C19.2923 6.51638 19.4248 7.04042 19.4248 7.56446Z",
    fill: "#315E45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81193 3.00781H0.333168C0.134527 3.00781 -0.0199669 3.19009 0.00210241 3.39516L0.0683146 3.94199C0.200743 4.46603 0.664233 4.85333 1.19394 4.85333H2.14299V3.34958C2.14299 3.1673 2.01056 3.00781 1.81193 3.00781Z",
    fill: "#315E45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6142 3.00781H19.0929C19.2916 3.00781 19.446 3.19009 19.424 3.39516L19.3578 3.94199C19.2253 4.46603 18.7619 4.85333 18.2321 4.85333H17.2831V3.34958C17.2831 3.1673 17.4155 3.00781 17.6142 3.00781Z",
    fill: "#315E45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28113 7.74683V8.17971C1.28113 8.43035 1.43563 8.63542 1.65634 8.70375L4.98904 9.86578L6.18091 7.74683H1.28113Z",
    fill: "#E1F4D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1876 7.74683V8.17971C18.1876 8.43035 18.0331 8.63542 17.8124 8.70375L14.4797 9.86578L13.2878 7.74683H18.1876Z",
    fill: "#E1F4D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0327 11.7113L15.6065 12.3948C15.761 12.5771 15.8493 12.805 15.8493 13.0328V14.2631H3.64404V13.0328C3.64404 12.805 3.73231 12.5771 3.88684 12.3948L4.46068 11.7113C4.63723 11.5062 4.88 11.3923 5.14487 11.3923H14.3264C14.5913 11.3923 14.8561 11.5062 15.0327 11.7113Z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3237 1.79092C14.9971 1.32377 14.4528 1.05127 13.8432 1.05127H5.13497C4.5254 1.05127 3.98113 1.32377 3.65455 1.79092L2 4.2045H17L15.3237 1.79092Z",
    fill: "#E1F4D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5994 9.97596L12.9473 10.2093H6.46269L5.82874 9.97596L6.78875 8.16748H12.6213L13.5994 9.97596Z",
    fill: "#E1F4D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6995 13.7165H7.77086C7.61633 13.7165 7.50598 13.5798 7.50598 13.4431V12.7368C7.50598 12.5773 7.6384 12.4634 7.77086 12.4634H11.6995C11.854 12.4634 11.9643 12.6001 11.9643 12.7368V13.4431C11.9864 13.6026 11.854 13.7165 11.6995 13.7165Z",
    fill: "#315E45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbercar);
export default __webpack_public_path__ + "static/media/ubercar.c8ed1849dbc8ecf866695e5e97bc8785.svg";
export { ForwardRef as ReactComponent };